import type { FilterKeys, FilterOptionsMap, PageFilterKeys } from '../types';

const steamGameStoreFilter: Array<FilterKeys> = [
  'starredTag',
  'refunded',
  'freePlayed',
  'steamPurchase',
  'recordTimes',
  'reviewTimes',
];

const steamRelatedFilter: Array<FilterKeys> = [
  'steamIds',
  'starredTag',
  'refunded',
  'freePlayed',
  'steamPurchase',
  'earlyAccess',
  'funnys',
  'helpfuls',
  'recordTimes',
  'reviewTimes',
  'product',
];

export const defaultFilter: Array<FilterKeys> = [
  'date',
  'language',
  'channel',
  'sentiment',
  'rating',
  'monitor',
  'topic',
  'invalid',
  'reviewType',
  'keyWords',
  'engagementsRange',
  'commentsRange',
  'likesRange',
  'sharesRange',
  'region', // 'regionAndLanguage',
  'postAuthorType',
];

const topicDefaultFilter: Array<FilterKeys> = [
  'date',
  'language',
  'channel',
  'sentiment',
  'rating',
  'monitor',
  'topic',
  'invalid',
  'reviewType',
  'engagementsRange',
  'commentsRange',
  'likesRange',
  'sharesRange',
  'region', // 'regionAndLanguage',
  'postAuthorType',
];

const topicFilterOptionsMap: {
  pc: Array<FilterKeys>;
  console: Array<FilterKeys>;
  mobile: Array<FilterKeys>;
} = {
  pc: [...topicDefaultFilter, 'monitorSource', ...steamGameStoreFilter],
  console: [...topicDefaultFilter, 'monitorSource', 'platform'],
  mobile: [...topicDefaultFilter, 'version'],
};

const PCFilter: Array<FilterKeys> = [
  ...defaultFilter,
  'monitorSource',
  ...steamGameStoreFilter,
  'aigc',
];
const ConsoleFilter: Array<FilterKeys> = [
  ...defaultFilter,
  'monitorSource',
  'platform',
  'aigc',
];
const MobileFilter: Array<FilterKeys> = [...defaultFilter, 'version', 'aigc'];

const defaultFilterOptionsMap = {
  pc: PCFilter,
  console: ConsoleFilter,
  mobile: MobileFilter,
};

// 处理version过滤器
const newPcFilter = [...PCFilter];
newPcFilter.splice(0, 1, 'versionTime');

const newMobileFilter = [...MobileFilter];
newMobileFilter.splice(0, 1, 'versionTime');

const newConsoleFilter = [...ConsoleFilter];
newConsoleFilter.splice(0, 1, 'versionTime');
const defaultVersionFilterOptionsMap = {
  pc: newPcFilter,
  console: newConsoleFilter,
  mobile: newMobileFilter,
};

export const pageFilterOptionsMap: {
  [key in PageFilterKeys]: Array<FilterKeys> | FilterOptionsMap;
} = {
  Overview_Performance: {
    pc: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      'keyKol',
      ...steamRelatedFilter,
      'invalid',
      'reviewType',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'monitorSource',
      'videoType',
      'liveVenues',
      'reviewers',
      'region', // 'regionAndLanguage',
      'postAuthorType',
      'aigc',
    ],
    console: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      'keyKol',
      'invalid',
      'reviewType',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'region', // 'regionAndLanguage',
      'monitorSource',
      'platform',
      'liveVenues',
      'reviewers',
      'videoType',
      'postAuthorType',
      'aigc',
    ],
    mobile: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      'keyKol',
      'invalid',
      'reviewType',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'region', // 'regionAndLanguage',
      'version',
      'liveVenues',
      'reviewers',
      'videoType',
      'postAuthorType',
      'aigc',
    ],
  },
  Key_Metrics: {
    pc: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      'keyKol',
      ...steamRelatedFilter,
      'invalid',
      'reviewType',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'monitorSource',
      'videoType',
      'liveVenues',
      'reviewers',
      'region', // 'regionAndLanguage',
      'postAuthorType',
      'aigc',
    ],
    console: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      'keyKol',
      'invalid',
      'reviewType',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'region', // 'regionAndLanguage',
      'monitorSource',
      'platform',
      'liveVenues',
      'reviewers',
      'videoType',
      'postAuthorType',
      'aigc',
    ],
    mobile: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      'keyKol',
      'invalid',
      'reviewType',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'region', // 'regionAndLanguage',
      'version',
      'liveVenues',
      'reviewers',
      'videoType',
      'postAuthorType',
      'aigc',
    ],
  },
  Summary_Keywords_Drill: {
    pc: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      ...steamRelatedFilter,
      'invalid',
      'reviewType',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'monitorSource',
      'videoType',
      'liveVenues',
      'reviewers',
      'region', // 'regionAndLanguage',
      'postAuthorType',
      'commentsUnderThePostContainingKeywordsIncluded',
      'aigc',
    ],
    console: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      'invalid',
      'reviewType',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'region',
      'monitorSource',
      'platform',
      'liveVenues',
      'reviewers',
      'videoType',
      'postAuthorType',
      'commentsUnderThePostContainingKeywordsIncluded',
      'aigc',
    ],
    mobile: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      'invalid',
      'reviewType',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'region',
      'version',
      'liveVenues',
      'reviewers',
      'videoType',
      'postAuthorType',
      'commentsUnderThePostContainingKeywordsIncluded',
      'aigc',
    ],
  },
  Overview_Hero: [
    'date',
    'language',
    'channel',
    'hero',
    'monitor',
    'reviewType',
    'region', // 'regionAndLanguage',
    'postAuthorType',
  ],
  Overview_NIKKE: [
    'date',
    'language',
    'channel',
    'NIKKE',
    'monitor',
    'reviewType',
    'region', // 'regionAndLanguage',
    'postAuthorType',
  ],
  Summary_TopicTracking: {
    mobile: [
      'date',
      'topic',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'invalid',
      'reviewType',
      'version',
      'liveVenues',
      'subTopicSentiment',
      'region', // 'regionAndLanguage',
      'postAuthorType',
      'aigc',
    ],
    pc: [
      'date',
      'topic',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      ...steamRelatedFilter,
      'invalid',
      'reviewType',
      'liveVenues',
      'subTopicSentiment',
      'region', // 'regionAndLanguage',
      'postAuthorType',
      'aigc',
    ],
    console: [
      'date',
      'topic',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'invalid',
      'reviewType',
      'liveVenues',
      'subTopicSentiment',
      'region', // 'regionAndLanguage',
      'postAuthorType',
    ],
  },
  Summary_TopicTracking_Report: ['date'],
  Summary_HotEvent: [],
  SteamPerformance: [
    'date',
    'language',
    'steamRating',
    'sentiment',
    'topic',
    'steamIds',
    'starredTag',
    'refunded',
    'freePlayed',
    'steamPurchase',
    'earlyAccess',
    'funnys',
    'helpfuls',
    'recordTimes',
    'reviewTimes',
    'product',
    'invalid',
    'keyWords',
  ],
  GameStore_Critic_Sites: ['date', 'sentiment', 'rating', 'topic', 'invalid'],
  GameStore_Xbox: [
    'date',
    // 'language',
    'sentiment',
    'rating',
    'topic',
    'invalid',
    'region',
  ],
  GameStore_Playstation: ['date', 'region'],
  // 注意： 这个还可以给收藏使用
  GameStore: {
    mobile: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'topic',
      'invalid',
      'version',
      'region', // 'regionAndLanguage',
    ],
    pc: ['date', 'language', 'sentiment', 'rating', 'topic', 'invalid'],
    console: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'topic',
      'invalid',
    ],
  },
  Report_GPT: ['gptSelect'],
  Stats_Channel: defaultFilterOptionsMap,
  Stats_Region: defaultFilterOptionsMap,
  Stats_Language: defaultFilterOptionsMap,
  Stats_Version: defaultVersionFilterOptionsMap,
  Stats_Topic: topicFilterOptionsMap,
  Stats_Keyword: defaultFilterOptionsMap,
  Stats_Keyword_Correlation: ['date', 'language', 'sentiment'],
  Stats_News: [
    'date',
    'channel',
    'sentiment',
    'topic',
    'newsUVPM',
    'engagementsRange',
    'newsDataSource',
    'newsCoverageType',
    'newsBate',
    'matchedType',
    'keyWords',
    'region', // 'regionAndLanguage',
  ],
  Feeds_Social_Media: [
    'date',
    'language',
    'channel',
    'sentiment',
    'monitor',
    'topic',
    'invalid',
    'reviewType',
    'reviewers',
    'keyWords',
    'engagementsRange',
    'commentsRange',
    'likesRange',
    'sharesRange',
    // 'sentimentClause',
    'liveVenues',
    'videoType',
    'urlAnalysis',
    'sentimentEditStatus',
    'region', // 'regionAndLanguage',
    'postAuthorType',
    'aigc',
  ],
  Feeds_Game_Store: {
    mobile: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'topic',
      'invalid',
      'reviewType',
      'reviewers',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      // 'sentimentClause',
      'version',
      'sentimentEditStatus',
      'region', // 'regionAndLanguage',
    ],
    pc: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'topic',
      ...steamRelatedFilter,
      'invalid',
      'reviewType',
      'reviewers',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      // 'sentimentClause',
      'monitorSource',
      'sentimentEditStatus',
      'region', // 'regionAndLanguage',
    ],
    console: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'topic',
      'invalid',
      'reviewType',
      'reviewers',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      // 'sentimentClause',
      'monitorSource',
      'platform',
      'sentimentEditStatus',
      'region', // 'regionAndLanguage',
    ],
  },
  Feeds_News_Media: [
    'date',
    'language',
    'channel',
    'sentiment',
    'topic',
    'newsUVPM',
    'engagementsRange',
    'newsDataSource',
    'newsCoverageType',
    'newsBate',
    'matchedType',
    'keyWords',
    'region', // 'regionAndLanguage',
  ],
  Feeds_Chatting: [
    'date',
    'language',
    'sentiment',
    'monitor',
    'topic',
    'invalid',
    'reviewType',
    'postAuthorType',
  ],
  Feeds_Private_Source: [
    'date',
    'language',
    'channel',
    'sentiment',
    'monitor',
    'topic',
    'invalid',
    'reviewType',
    'postAuthorType',
  ],
  Feeds_Player_Feedback: [
    'date',
    'language',
    'sentiment',
    'monitor',
    'topic',
    'reviewType',
    'postAuthorType',
  ],
  Competitor: [
    'date',
    'language',
    'channel',
    'sentiment',
    'invalid',
    'keyWords',
    'reviewType',
    'region', // 'regionAndLanguage',
  ],
  Competitor_Different_Start_Date: [
    'metrics',
    'regionAndLanguage', // 'regionAndLanguage',
    'channel',
    'sentiment',
    'manyCompareGame',
  ],
  Community_Video: [
    'date',
    'language',
    'channel',
    'sentiment',
    'monitor',
    'topic',
    'keyKol',
    'invalid',
    'reviewers',
    'keyWords',
    'engagementsRange',
    'commentsRange',
    'likesRange',
    'sharesRange',
    'videoType',
    'region', // 'regionAndLanguage',
    'postAuthorType',
    'videoAITag',
    'aigc',
  ],
  Influencer: [
    'date',
    'language',
    'channel',
    'keyKol',
    'followerRange',
    'views',
    'engagementsRange',
    'commentsRange',
    'likesRange',
    'sharesRange',
    'region', // 'regionAndLanguage',
  ],
  Community_Influencer: [
    'date',
    'language',
    'channel',
    'keyKol',
    'followerRange',
    // 'influencersType',
    'engagementsRange',
    'commentsRange',
    'likesRange',
    'sharesRange',
  ],
  GenreCreatorList: [
    'date',
    'genreGameAndAffinity',
    'brandAffinitys',
    'language',
    'keyKol',
    'followerRange',
    'totalPublications',
    'avgViews',
    'avgEngagementRate',
    'brandRelatedPublications',
    'brandRelatedAvgViews',
    'region', // 'regionAndLanguage',
  ],
  Community_Streaming: ['date', 'channel'],
  Community_Hashtag: [
    'date',
    'language',
    'channel',
    'hashtag',
    'sentiment',
    'monitor',
    'reviewType',
    'region', // 'regionAndLanguage',
    'postAuthorType',
  ],
  By_Channel: [
    'date',
    'region',
    'channel',
    'monitor',
    'reviewType',
    'postAuthorType',
  ],
  By_Account: [
    'date',
    'region',
    'channel',
    'monitor',
    'reviewType',
    'postAuthorType',
  ],
  DataMap_Opinions_Sources: ['dataSource', 'gameType', 'channelType'],
  Trending_Publications: [
    'date',
    'language',
    'channel',
    'topic',
    'monitor',
    'keyWords',
    'videoType',
    'region', // 'regionAndLanguage',
    'kolRegion',
    'aigc',
  ],
  Compare_Key_Metrics: [
    'date',
    'language',
    'competitorGames',
    'channel',
    'invalid',
    'keyWords',
    'region', // 'regionAndLanguage',
  ],
  Filter_Page: [
    'avgEngagementRate',
    'avgViews',
    'brandAffinitys',
    'brandRelatedAvgViews',
    'brandRelatedPublications',
    'channel',
    'channelType',
    'channelTypeSingle',
    'commentsRange',
    'dataSource',
    'date',
    'earlyAccess',
    // 'engagementPerformance',
    'engagementsRange',
    'followerRange',
    'freePlayed',
    'steamPurchase',
    'funnys',
    'product',
    'gameAffinitys',
    'gameType',
    'genreGameList',
    'gptSelect',
    'hashtag',
    'helpfuls',
    'hero',
    'influencersType',
    'invalid',
    'keywordFilterType',
    'keyWords',
    'language',
    'likesRange',
    'liveVenues',
    'matchedType',
    'monitor',
    'monitorSource',
    'newsBate',
    'newsCoverageType',
    'newsDataSource',
    'newsUVPM',
    'perspective',
    'platformGame',
    'platform',
    'rating',
    'recordTimes',
    'refunded',
    'region',
    'reviewers',
    'reviewTimes',
    // 'sentimentClause',
    'sentiment',
    'sharesRange',
    'starredTag',
    'steamIds',
    'steamRating',
    'topic',
    'totalPublications',
    'version',
    'versionTime',
    'videoTag',
    'competitorGames',
    'genreGameAndAffinity',
    'kolTags',
    'videoType',
    'views',
    'postAuthorType',
  ],
  Voice_Reporting_Text_Analysis: [
    'date',
    'voiceLanguage',
    'sentiment',
    'intent',
  ],
  Channel_Share_Rankings: ['date', 'language', 'levelUpGame'],
  Custom_AI_Summary: {
    pc: [
      'date',
      'language',
      'channel',
      'sentiment',
      'rating',
      'monitor',
      'topic',
      ...steamRelatedFilter,
      'invalid',
      'reviewType',
      'keyWords',
      'engagementsRange',
      'commentsRange',
      'likesRange',
      'sharesRange',
      'monitorSource',
      'videoType',
      'liveVenues',
      'reviewers',
      'region', // 'regionAndLanguage',
      'postAuthorType',
      'aigc',
    ],
    console: [...ConsoleFilter, 'liveVenues', 'reviewers', 'videoType', 'aigc'],
    mobile: [...MobileFilter, 'liveVenues', 'reviewers', 'videoType', 'aigc'],
  },
  Common_Page: ['date'],
  PUBGM_Weekly_Report: ['date', 'channel', 'language', 'topic'],
  Ads_Overview: ['date'],
  Marketing_Trending_Publications: [
    'zoneGames',
    'date',
    'language',
    'channel',
    'topic',
    'keyWords',
    'videoType',
    'region', // 'regionAndLanguage',
    'kolRegion',
    'aigc',
  ],
  SteamPerformance_VersionAnalysis: [
    'date',
    'language',
    'steamRating',
    'sentiment',
    'topic',
    'steamIds',
    'starredTag',
    'refunded',
    'freePlayed',
    'steamPurchase',
    'earlyAccess',
    'funnys',
    'helpfuls',
    'recordTimes',
    'reviewTimes',
    'product',
    'invalid',
    'keyWords',
  ],
};

// 偏差矫正，用于hashtag和keyword filter区别
export const deviationKeys: any = {
  keyWords: 'keyword',
};

export const filterKeyMapValueKey: {
  [key in FilterKeys]?: Array<string> | string;
} = {
  channel: [
    'channel',
    'channel_social',
    'channel_news',
    'channel_comments',
    'channel_type',
  ],
  invalid: 'is_valid',
  monitor: ['social_media_by_account', 'social_media_by_keyword'],
  rating: 'reviews_rating',
  steamRating: 'reviews_rating',
  regionAndLanguage: ['language', 'logic', 'region', 'region_type'],
  language: 'language',
  region: 'region',
  sentiment: 'sentiment',
  topic: 'topic',
  version: 'version',
  monitorSource: 'monitor_scource',
  hero: 'keyword_en',
  hashtag: 'keyword',
  keyWords: ['keyWords', 'keyword_filter_types'],
  gptSelect: ['start_time', 'end_time', 'language', 'date_type'],
  dataSource: 'data_source',
  gameType: 'game_type',
  channelType: 'channel_type',
  videoTag: 'video_labels',
  commentsRange: 'comments',
  engagementsRange: 'engagements',
  sharesRange: 'shares',
  likesRange: 'likes',
  reviewType: 'review_types',
  matchedType: 'matched_type',
  sentimentClause: 'sentiment_clause',
  keywordFilterType: 'keyword_filter_types',
  influencersType: 'officials',
  freePlayed: 'free_played',
  starredTag: 'starred_tag',
  refunded: 'refunded',
  recordTimes: 'record_times',
  reviewTimes: 'review_times',
  earlyAccess: 'early_access',
  funnys: 'funnys',
  helpfuls: 'helpfuls',
  brandAffinitys: 'brand_affinitys',
  genreGameAndAffinity: ['game_covereds', 'affinity_type', 'game_affinitys'],
  totalPublications: 'publications',
  avgViews: 'avg_views',
  avgEngagementRate: 'avg_engagements_rate',
  brandRelatedPublications: 'brand_publications',
  brandRelatedAvgViews: 'avg_brand_views',
  genreGameList: 'game_covereds',
  followerRange: 'followers',
  videoType: 'video_types',
  postStream: 'posts',
  postAuthorType: 'organization',
  kolRegion: 'kol_countrys',
  videoAITag: 'video_tags',
  zoneGames: 'zone_games',
  blackGrayAuthor: 'black_gray_author_filter',
  aigc: 'aigc',
};
